// import usePermission from 'permission/usePermission';
import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { PAGE_NAMES } from 'constant';

import dashboard from 'assets/home/dashboard.png';
// import settings from 'assets/home/settings.png';
import settingsV2 from 'commons-ui/src/assets/settingsV2/settingV2Icon.png';
import bulkActions from 'assets/home/admin.png';
import miscellaneous from 'assets/home/miscellaneous.png';

const useMenuItems = () => {
	// const { hasPermission } = usePermission();
	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	const menuItems = [
		{
			label: 'User Profile',
			img: dashboard,
			url: `/${PAGE_NAMES.userProfile}`,
			isEnabled: () => {
				return hasPermissionV2({ configPageName: PAGE_NAMES.userProfile });
			}
		},
		// {
		// 	label: 'Settings',
		// 	img: settings,
		// 	url: `/${PAGE_NAMES.settings}`,
		// 	isEnabled: () => {
		// 		return hasPermission({ configPageName: PAGE_NAMES.settings, requiredPermissionLevel: 'read' });
		// 	}
		// },
		{
			label: 'User And Permissions Settings',
			img: settingsV2,
			url: `/${PAGE_NAMES.settingsV2}`,
			isEnabled: () => {
				return hasPermissionV2({ configPageName: PAGE_NAMES.settingsV2 });
			}
		},
		{
			label: 'Bulk Actions',
			img: bulkActions,
			url: `/${PAGE_NAMES.bulkActions}`,
			isEnabled: () => {
				return hasPermissionV2({ configPageName: PAGE_NAMES.bulkActions });
			}
		},
		{
			label: 'Miscellaneous',
			img: miscellaneous,
			url: `/${PAGE_NAMES.miscellaneous}`,
			isEnabled: () => {
				return hasPermissionV2({ configPageName: PAGE_NAMES.miscellaneous });
			}
		}
	];

	return {
		menuItems
	};
};

export default useMenuItems;
